<template>
  <div class="invite-box">
    <van-nav-bar title="我的邀请" left-arrow @click-left="$router.go(-1)" />
    <div class="invite-img" ref="box">
      <img src="../../assets/images/mine/invite.png" />
      <div class="qrcode" ref="qrCodeUrl"></div>
      <div class="code">{{ inviteCode }}</div>
    </div>
    <div class="tips-content">
      <van-button type="warning" @click="copy(inviteLink)">复制链接</van-button>
      <van-button type="warning" @click="copy(inviteLink)">分享海报</van-button>
      <div class="tips">
        好友使用你的邀请码成功注册后，Ta将成为你的粉丝，粉丝下单，你也可以获得收益哦！
      </div>
    </div>
  </div>
</template>


<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      inviteCode: "",
      inviteList: [], // 邀请列表
      page: 1,
      total: 10,
      img: null,
    };
  },
  computed: {
    inviteLink() {
      return window.location.origin+"/#/reg?code=" + this.inviteCode;
    },
  },
  created() {
    this.Post({}, "/main/userinfo", (res) => {
      if (res.states == 1) {
        this.inviteCode = res.data.inviteCode;
      } else if (res.states == 400) {
        this.$router.replace("/login");
      } else {
        this.Toast.fail(res.msg);
      }
    });
  },
  mounted() {
    this.creatQrCode();
  },
  methods: {
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: "邀请海报", // 需要转换为二维码的内容
        width: 80,
        height: 80,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      setTimeout(() => {
        this.makeImg();
      }, 1000);
    },
    makeImg() {
      //合成分享图
      html2canvas(this.$refs.box).then((canvas) => {
        let dataURL = canvas.toDataURL("image/png");
        // this.img = dataURL;
        // this.downloadFile(dataURL);
      });
    },
    //下载base64图片
    downloadFile(dataURL) {
      const imgUrl = dataURL;
      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        var bstr = atob(imgUrl.split(",")[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "chart-download" + "." + "png");
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement("a");
        a.href = imgUrl;
        a.setAttribute("download", "chart-download");
        a.click();
      }
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.invite-box {
  padding-bottom: 15px;
  .invite-img {
    position: relative;
    padding: 10px 0;
    text-align: center;
    img {
      width: 300px;
      border-radius: 8px;
    }
    .qrcode {
      position: absolute;
      left: 50%;
      margin-left: -40px;
      bottom: 148px;
    }
    .code {
      position: absolute;
      bottom: 100px;
      color: #ffffff;
      letter-spacing: 1px;
      font-size: 14px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .tips-content {
    box-sizing: border-box;
    margin: 0 auto;
    background: #ffffff;
    width: 300px;
    border-radius: 8px;
    padding: 10px;
    .tips {
      padding-top: 6px;
      line-height: 1.5;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/mine/invite.vue